<template>
  <div>
    <v-card>
      <div >
        <v-data-table
                :search="search"
                dense
                @page-count="pageCount = $event"
                :page.sync="page"
                :headers="headers"
                :header-props="headerProps"
                :items="rowData"
                sort-by="calories"
                mobile-breakpoint="900"
                :footer-props="{
                   showFirstLastPage: false,
                     'items-per-page-text':'linhas por página',
                     itemsPerPageOptions:[5,10,20,30,40,50]
                  }"
                class="border elevation-1"
                no-data-text="Nenhum registro disponível"
                no-results-text="Nenhum registro encontrado"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-text-field
                      full-width
                      class="mr-3"
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Busca"
                      outlined
                      dense
                      single-line
                      hide-details
              ></v-text-field>
            </v-toolbar>
          </template>
          <template v-if="rowData.length != 0" v-slot:footer.page-text="props">
            {{props.pageStart}} - {{props.pageStop}} de {{props.itemsLength}}
          </template>
        </v-data-table>

<!--        <div class="text-center pt-2">-->
<!--          <v-pagination class="custom" v-model="page" btn="btn" :length="pageCount"></v-pagination>-->
<!--        </div>-->
      </div>
    </v-card>
  </div>
</template>

<script>



export default {
    name:'PermissionList',
    data: () => {
        return {
            accessedArea: 'permissions',
            addNewDataSidebar: false,
            search: "",
            page: 1,
            headerProps: {
                sortByText: "buscar por"
            },
            pageCount: 0,
            headers: [
                { text: "Menu", align: "left", value: "menu" },
                { text: "Grupo", align: "left", value: "group" },
                { text: "Nome", align: "left", value: "name" },
                { text: "Descrição", align: "left", value: "description" },
            ],
            permissions: {
                create: true,
                update: true,
                delete: true
            },
            rowData: []
        }
    },
    apollo: {
        rowData: {
            query: require('@/graphql/queries/Permission.gql').getPermissions,
            update: data => data.permissions
        }
    },
    mounted() {
        this.$apollo.queries.rowData.refetch()
    }
}
</script>
